// extracted by css-extract-rspack-plugin
export default {"root":"OdCIXE","llama-part":"nvl1cp","llamaPart":"nvl1cp","llama-icon":"A9wo8Y","llamaIcon":"A9wo8Y","llama-text":"JXQHgC","llamaText":"JXQHgC"};